import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'tasks',
  children: {
    new: {
      path: 'new',
    },
    taskId: {
      path: ':taskId',
    },
    taskIdAndIdentifier: {
      path: ':taskId/:identifier',
    },
  },
} as const satisfies Location
